var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 7,
    viewBox: "0 0 19 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.444088 4H17.5592L15.594 6.18863C15.4292 6.37424 15.4292 6.67518 15.594 6.86079C15.7588 7.0464 16.026 7.0464 16.1908 6.86079L18.8764 3.83608C19.0412 3.65047 19.0412 3.34953 18.8764 3.16392L16.1908 0.139209C16.026 -0.0464029 15.7588 -0.0464028 15.594 0.139209C15.4292 0.32482 15.4292 0.625755 15.594 0.811367L17.5592 3H0.444088C0.440011 2.99987 0.435921 2.99981 0.431818 2.99981C0.193332 2.99981 0 3.23718 0 3.49968C0 3.76217 0.205602 3.99999 0.444088 4Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.7da35c325e7e2086b562f90dc2b64639.svg";
export { ForwardRef as ReactComponent };